import { FormControl, Grid, ListItem, ListItemIcon, ListItemText, MenuItem, Select, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { getEnumOptionsById } from "../constants/mainNavbarItems";

const ParameterRow = React.memo(({ param, onChange, onFocus, onBlur,handleAddFavParam,handleRemoveFavParam,favParamData }) => {
  const [localValue, setLocalValue] = useState(param.value);
  const isEditingRef = useRef(false);
  const [dropDownOptions, setDropDownOptions] = useState([]);

  // Sync localValue only if not editing
  useEffect(() => {
    if (!isEditingRef.current) {
      setLocalValue(param.value);
    }
    if(param.data_type === 8) {
        const options = getEnumOptionsById(param.enum_type);
        setDropDownOptions(options);
    }
  }, [param.value]);

  const handleFocus = () => {
    isEditingRef.current = true;
    onFocus(param.id);
  };

  const handleBlur = () => {
    isEditingRef.current = false;
    onBlur(param.id);
    onChange(localValue); // commit on blur
  };



  return (
    <div>
      <Grid container>
      <ListItem
        key={param.id}
        sx={{ 
            pt:0,
            pb:0, 
            width: '87%',
            marginLeft:'10px', 
            marginBottom: '4px', 
            border: '1px solid #DCE2E8', 
            borderRadius: '4px' , 
            //background : backGroundColor 
        }}
      >
            <ListItemText 
                sx={{ color: '#1F1F1F' }} 
                primary={<Typography sx={{fontSize:'0.60rem'}} >{ param.label }</Typography>} 
            />
            {param.data_type === 8 ?
                <>
                <FormControl style={{width: '31%'}}>
                    <Select 
                        disabled={param.type === 'signal'}
                        value={Math.floor(localValue) || 0}
                        sx={{
                            borderRadius:'0px',
                            fontSize: '0.75rem',
                            color:'#8E7863',
                            '& .MuiSelect-select': {
                                paddingLeft: '8px',
                                paddingTop: '3px',
                                paddingBottom: '3px',
                            }
                        }}
                        onChange={(e) => setLocalValue(e.target.value)}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                    >
                        {dropDownOptions?.values?.length > 0 && dropDownOptions?.values?.map(option => (
                            <MenuItem 
                                sx={{fontSize:'0.65rem'}}
                                key={option.id} 
                                value={option.id}
                            >{option.label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <span className="unitSpan">{param.type !== 'signal' ? param.unit : ''}</span>
                </>
            : 
            <>
                <input
                    value={param.type === 'signal' ? `${localValue} ${param.unit}` : `${localValue}`}
                    onChange={(e) => setLocalValue(e.target.value)}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    disabled={param.type === 'signal'}
                    className={param.type === 'signal' ? 'paramChange withOutBorder' : 'paramChange'} 
                />
                <span className="unitSpan">{param.type !== 'signal' ? param.unit : ''}</span>
            </>
            }
      </ListItem>
      <ListItem sx={{width: '10%'}}>
            <ListItemIcon> 
                { favParamData.current.has(param.id) ?
                    <BookmarkIcon onClick={() => handleRemoveFavParam(param)} sx={{cursor:'pointer',color:'#5B81C5'}}  fontSize='small' />
                    :
                    <BookmarkIcon onClick={()=>handleAddFavParam(param)} sx={{cursor:'pointer',color:'#DCE2E8'}}  fontSize='small' />  
                }
            </ListItemIcon>
        </ListItem>
      </Grid>  
    </div>
  );
});

export default ParameterRow;
